<section class="organigrama-section">

  <div class="organigrama-container">

    <h2>ORGANIGRAMAS CSH - UIPC</h2>

    <p class="subinfo">
      ITESCARCEGA – PROTECCIÓN CIVIL Y ACCESIBILIDAD – Última actualización: 09 Septiembre 2025 – Visitas: 9854
    </p>

    <h4>UNIDAD INTERNA DE PROTECCIÓN CIVIL</h4>

  
    <div id="carouselOrganigrama" class="carousel slide" data-bs-ride="carousel">

      <div class="carousel-inner">

        <div class="carousel-item active">
          <img src="assets/carrusel_proteccion_civil/organigrama_protecion.jpeg" class="d-block w-100">
        </div>

        <div class="carousel-item">
          <img src="assets/carrusel_proteccion_civil/brigada.jpeg" class="d-block w-100">
        </div>

        <div class="carousel-item">
          <img src="assets/carrusel_proteccion_civil/brigada_prevencion.jpeg" class="d-block w-100">
        </div>

        <div class="carousel-item">
          <img src="assets/carrusel_proteccion_civil/brigada_comunicacion.jpeg" class="d-block w-100">
        </div>

        <div class="carousel-item">
          <img src="assets/carrusel_proteccion_civil/brigada_evaluacion.jpeg" class="d-block w-100">
        </div>
        <div class="carousel-item">
          <img src="assets/carrusel_proteccion_civil/primeros_auxilios.jpeg" class="d-block w-100">
        </div>

      </div>

      <!-- BOTONES -->
      
      <button class="carousel-control-prev custom-arrow" type="button" data-bs-target="#carouselOrganigrama" data-bs-slide="prev">
  <span class="carousel-control-prev-icon"></span>
</button>

<button class="carousel-control-next custom-arrow" type="button" data-bs-target="#carouselOrganigrama" data-bs-slide="next">
  <span class="carousel-control-next-icon"></span>
</button>

    </div>
  </div>
</section>

<section class="csh-section">

  <div class="csh-container">

    <h2>COMISIÓN DE SEGURIDAD E HIGIENE</h2>

    <!-- IMAGEN -->
    <div class="csh-img">
      <img src="assets/carrusel_proteccion_civil/comision_higiene.jpg" alt="Comisión de Seguridad e Higiene">
    </div>

  </div>

</section>


    <!-- PDF -->
    <h5>PRESENTACIÓN DEL SIMULACRO NACIONAL 2025</h5>

    <div class="pdf-container">
      <iframe 
        src="assets/carrusel_proteccion_civil/pdf_simulacro.pdf" 
        frameborder="0">
      </iframe>
    </div>

     <!-- PDF -->
    <h5>PROCEDIMIENTOS DE EMERGENCIA DEL CAMPUS ESCARCEGA DEL TECNM</h5>

    <div class="pdf-container">
      <iframe 
        src="assets/carrusel_proteccion_civil/procedimientos_emergencia.pdf" 
        frameborder="0">
      </iframe>
    </div>

     <!-- PDF -->
    <h5>PROTOCOLO INTERNO DE EVACUACION DE PERSONAS CON DISCAPACIDAD, MUJERES EMBARAZADAS Y ADULTOS MAYORES</h5>

    <div class="pdf-container">
      <iframe 
        src="assets/carrusel_proteccion_civil/protocolo_adultos_mayores.pdf" 
        frameborder="0">
      </iframe>
    </div>